<template>
  <span>
    <span key="is-number" v-if="isNumber">{{
      value | formatCurrency(currency, { actualNumber })
    }}</span>
    <span key="is-not-number" v-else>{{ errorText }}</span>
  </span>
</template>

<script>
export default {
  name: 'AppCurrency',
  props: {
    value: Number,
    currency: {
      type: String,
      default: 'JPY',
    },
    errorText: {
      type: String,
      default: '----',
    },
    actualNumber: Boolean,
  },
  computed: {
    isNumber() {
      return !isNaN(Number(this.value))
    },
  },
}
</script>
